import aih from './aih'
import assinaturaEletronica from './assinaturaEletronica'
import assistenciaSocial from './assistenciaSocial'
import atendimentoEnfermagem from './atendimentoEnfermagem'
import atendimentoMedico from './atendimentoMedico'
import atendimentoRecepcao from './atendimentoRecepcao'
import atendimentoRetroativo from './atendimentoRetroativo'
import atendimentoTriagem from './atendimentoTriagem'
import cancelamentoEvasao from './cancelamentoEvasao'
import classificacaoRisco from './classificacaoRisco'
import exameImagem from './atendimentoExameImagem'
import fechamentoFaa from './fechamentoFaa'
import fechamentoFaaMassa from './fechamentoFaaMassa'
import filaAtendimento from './filaAtendimento'
import impressaoFaaEletronica from './impressaoFaaEletronica'
import impressoes from './impressoes'
import observacao from './pacienteObservacao'
import pacienteBusca from './pacienteBusca'
import parametrizacao from './parametrizacao'
import plantao from './plantao'
import reaberturaAtendimento from './reaberturaAtendimento'
import regularizacaoCadastro from './regularizacaoCadastro'
import relatorioAtendimento from './relatorioAtendimento'
import relatorioClassificacaoRisco from './relatorioClassificacaoRisco'
import relatorioDocumentoNaoAssinado from './relatorioDocumentoNaoAssinado'
import relatorioExameImagem from './relatorioExameImagem'
import relatorioPlantao from './relatorioPlantao'
import relatorioPrescricaoInterna from './relatorioPrescricaoInterna'
import relatorioProducaoMedico from './relatorioProducaoMedico'
import relatorioQuantitativoProducao from './relatorioQuantitativoProducao'

export default [
    {
        path: 'pronto-atendimento',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...aih,
            ...assinaturaEletronica,
            ...assistenciaSocial,
            ...atendimentoEnfermagem,
            ...atendimentoMedico,
            ...atendimentoRecepcao,
            ...atendimentoRetroativo,
            ...atendimentoTriagem,
            ...cancelamentoEvasao,
            ...classificacaoRisco,
            ...exameImagem,
            ...fechamentoFaa,
            ...fechamentoFaaMassa,
            ...filaAtendimento,
            ...impressaoFaaEletronica,
            ...impressoes,
            ...observacao,
            ...pacienteBusca,
            ...parametrizacao,
            ...plantao,
            ...reaberturaAtendimento,
            ...regularizacaoCadastro,
            ...relatorioAtendimento,
            ...relatorioClassificacaoRisco,
            ...relatorioDocumentoNaoAssinado,
            ...relatorioExameImagem,
            ...relatorioPlantao,
            ...relatorioPrescricaoInterna,
            ...relatorioProducaoMedico,
            ...relatorioQuantitativoProducao,
        ]
    }
]